// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
    fileTransactions: File | null;
    fileInvoices: File | null;
    matchResult: any;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Toolbox-MatchTransactions',
    templateUrl: './MatchTransactions.html',
    styleUrls: ['./MatchTransactions.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MatchTransactions extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Toolbox.MatchTransactions';
    $isDialog = false;
    $Modules = $Modules;
    Toolbox = Toolbox;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    $validators: Record<number, ValidationRules> = {

    };
    var_fileTransactions = proxySignal<File | null>(undefined as any);
    var_fileInvoices = proxySignal<File | null>(undefined as any);
    var_matchResult = proxySignal<any>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get fileTransactions() { return component.var_fileTransactions() },
                set fileTransactions(value: File | null) { component.var_fileTransactions.set(value) },
                get fileInvoices() { return component.var_fileInvoices() },
                set fileInvoices(value: File | null) { component.var_fileInvoices.set(value) },
                get matchResult() { return component.var_matchResult() },
                set matchResult(value: any) { component.var_matchResult.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {

        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this
            if (!isVariablesInitialized) this.screen.fileTransactions = (null)
            if (!isVariablesInitialized) this.screen.fileInvoices = (null)
            if (!isVariablesInitialized) this.screen.matchResult = (null)
            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    async handler_FileUploadBlock_31_filesSelected_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {
            let files: File[] = [...$event]
            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    const [file] = files;
                    screen.fileTransactions = file;
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_35_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    screen.fileTransactions = null
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_FileUploadBlock_62_filesSelected_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {
            let files: File[] = [...$event]
            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    const [file] = files;
                    screen.fileInvoices = file;
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_65_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    screen.fileInvoices = null
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_36_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    Sys.App.spinnerText = 'Matching...'
                    try {
                        screen.matchResult = await This.MatchingHelper.processFiles(await screen.fileTransactions.arrayBuffer(), await screen.fileInvoices.arrayBuffer())
                    } finally {
                        Sys.App.spinnerText = undefined
                    }
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_84_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    Sys.App.provideDownload(screen.matchResult.matchedContent, screen.matchResult.matchedFilename)
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_85_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    Sys.App.provideDownload(screen.matchResult.reportContent, 'Amex Matching Report.xlsx')
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {

        }
    }
}
